const WORDS = ["You are worthy", "You are deserving", "You are the gift", "Honoring the law of love"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="font-display italic font-light text-5xl sm:text-7xl text-[#2D2A26] px-8 whitespace-nowrap">{w}</span>
        <svg viewBox="0 0 24 24" className="w-6 h-6 text-[#A8613C]"><path d="M12 2l2.2 7.8L22 12l-7.8 2.2L12 22l-2.2-7.8L2 12l7.8-2.2z" fill="currentColor" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="py-10 sm:py-14 border-y border-[#E6E0D4] bg-[#F4F0E8] overflow-hidden" aria-label="Affirmations">
    <div className="flex w-max animate-marquee"><Row /><Row /></div>
  </section>
);
